import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<'basic' | 'pro'>('pro');
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 24,
    s: 44
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section id="pricing" className="py-16 bg-surface border-t border-white/5 relative overflow-hidden" aria-label="Precios y planes" data-id="element-267">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-268">
        <FadeIn data-id="element-269">
          <div className="text-center mb-10" data-id="element-270">
            <p className="text-xl md:text-2xl font-heading font-bold text-white mb-4" data-id="element-271">
              ⏰ PRECIO DE LANZAMIENTO
            </p>
            <div className="flex items-center justify-center gap-2 md:gap-4 text-3xl md:text-5xl font-heading font-bold text-gold" data-id="element-272">
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-273">
                {formatTime(timeLeft.h)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-274">
                  hs
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-275">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-276">
                {formatTime(timeLeft.m)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-277">
                  min
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-278">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-279">
                {formatTime(timeLeft.s)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-280">
                  seg
                </span>
              </div>
            </div>
            <p className="text-red-400 mt-4 font-medium" data-id="element-281">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-282">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white text-center mb-10" data-id="element-283">
            ELEGÍ TU <span className="text-gold" data-id="element-284">PACK</span>
          </h2>
        </FadeIn>

        <div id="elegir-plan" className="max-w-2xl mx-auto mb-16 scroll-mt-6" role="radiogroup" aria-label="Seleccionar plan" data-id="element-285">
          <FadeIn delay={0.05} data-id="element-286">
            <div className="mb-6" data-id="element-287">
              <div className="flex justify-between text-sm mb-2" data-id="element-288">
                <span className="text-gold font-bold flex items-center gap-2" data-id="element-289">
                  <span className="w-2 h-2 rounded-full bg-gold animate-pulse" data-id="element-290"></span>
                  Cupos al precio de lanzamiento — Quedan pocos
                </span>
                <span className="text-gray-400" data-id="element-291">84%</span>
              </div>
              <div className="w-full bg-surfaceLight rounded-full h-2.5 overflow-hidden border border-white/5" data-id="element-292">
                <div className="bg-gold h-2.5 rounded-full" style={{
                width: '84%'
              }} data-id="element-293"></div>
              </div>
            </div>
          </FadeIn>

          {/* Pack Base */}
          <FadeIn delay={0.1} data-id="element-294">
            <button onClick={() => setSelectedPlan('basic')} role="radio" aria-checked={selectedPlan === 'basic'} aria-label="SISTEMA MAESTRO PVC + DVH — COMPLETO — $19.990 ARS" className={`w-full text-left rounded-2xl p-6 mb-5 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'basic' ? 'border-gold shadow-[0_0_20px_rgba(212,168,67,0.15)] bg-surfaceLight/80' : 'border-white/10 bg-bg hover:border-white/20'}`} data-id="element-295">
              <div className="flex items-start gap-4" data-id="element-296">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'basic' ? 'border-gold' : 'border-gray-500'}`} data-id="element-297">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-298"></div>}
                </div>

                <div className="flex-1 min-w-0" data-id="element-299">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-300">
                    <div data-id="element-301">
                      <h3 className="text-lg font-heading font-bold text-white flex items-center gap-2 mb-1" data-id="element-302">
                        <span data-id="element-303">📘</span> SISTEMA MAESTRO PVC + DVH — COMPLETO
                      </h3>
                      <p className="text-gray-400 text-sm mb-3" data-id="element-304">
                        6 Módulos + 3 Bonos
                      </p>
                      <div className="bg-surfaceLight/50 px-3 py-2 rounded-lg border border-white/5 text-xs text-gray-300 inline-block" data-id="element-305">
                        <span className="font-semibold text-white" data-id="element-306">
                          Ideal para:
                        </span>{' '}
                        Carpinteros e instaladores que quieren trabajar con
                        sistema desde hoy
                      </div>
                    </div>
                    <div className="sm:text-right shrink-0" data-id="element-307">
                      <span aria-hidden="true" className="text-gray-500 line-through text-sm block" data-id="element-308">
                        $69.990
                      </span>
                      <span className="text-2xl font-heading font-bold text-white" data-id="element-309">
                        $19.990
                      </span>
                      <span className="text-sm text-gray-400 ml-1" data-id="element-310">ARS</span>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </FadeIn>

          {/* Pack Pro */}
          <FadeIn delay={0.2} data-id="element-311">
            <div id="pack-pro" className="relative my-6 scroll-mt-24" data-id="element-312">
              <div className="absolute -inset-0.5 rounded-3xl opacity-50 blur-md pointer-events-none" aria-hidden="true" style={{
              background: 'linear-gradient(135deg, rgba(212, 168, 67, 0.4) 0%, transparent 100%)'
            }} data-id="element-313"></div>
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-314">
                <span className="bg-gold text-bg font-bold px-5 py-1.5 rounded-full text-xs uppercase tracking-wider whitespace-nowrap shadow-lg" data-id="element-315">
                  ⭐ EL MÁS ELEGIDO
                </span>
              </div>
              <button onClick={() => setSelectedPlan('pro')} role="radio" aria-checked={selectedPlan === 'pro'} aria-label="SISTEMA MAESTRO + PACK DE ACELERACIÓN — $29.990 ARS" className={`relative w-full text-left rounded-3xl p-7 md:p-8 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'pro' ? 'border-gold shadow-[0_0_30px_rgba(212,168,67,0.2)] bg-surfaceLight' : 'border-gold/30 bg-surfaceLight/50 hover:border-gold/50'}`} data-id="element-316">
                <div className="flex items-start gap-4" data-id="element-317">
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'pro' ? 'border-gold' : 'border-gray-500'}`} data-id="element-318">
                    {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-319"></div>}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-320">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-321">
                      <div data-id="element-322">
                        <h3 className="text-xl md:text-2xl font-heading font-bold text-white flex items-center gap-2 mb-1" data-id="element-323">
                          <span data-id="element-324">🏆</span> SISTEMA MAESTRO + PACK DE ACELERACIÓN
                        </h3>
                        <p className="text-gold text-sm md:text-base font-medium mb-3" data-id="element-325">
                          6 Módulos + 3 Bonos + Módulo 7 Pack de Aceleración
                          completo
                        </p>
                        <div className="bg-gold/10 px-3 py-2 rounded-lg border border-gold/20 text-xs text-gray-200 inline-block" data-id="element-326">
                          <span className="font-semibold text-white" data-id="element-327">
                            Ideal para:
                          </span>{' '}
                          Talleres que quieren calcular, fabricar y presupuestar
                          sin errores y sin calculadora
                        </div>
                      </div>
                      <div className="sm:text-right shrink-0" data-id="element-328">
                        <span aria-hidden="true" className="text-gray-500 line-through text-sm block" data-id="element-329">
                          $97.910
                        </span>
                        <span className="text-4xl md:text-5xl font-heading font-bold text-gold" data-id="element-330">
                          $29.990
                        </span>
                        <span className="text-sm text-gold/80 ml-1" data-id="element-331">ARS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-332">
            <a id="cta-comprar" href={selectedPlan === 'pro' ? 'https://fegion.shop/cart/47115293393035:1' : 'https://fegion.shop/cart/47115288019083:1'} className="block w-full mt-8 py-5 text-center rounded-2xl font-heading font-bold transition-all shadow-lg uppercase tracking-wider text-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold bg-gold hover:bg-gold-light text-bg gold-box-glow" data-id="element-333">
              {selectedPlan === 'pro' ? '→ QUIERO EL SISTEMA + PACK DE ACELERACIÓN' : '→ QUIERO MI SISTEMA MAESTRO AHORA'}
            </a>
          </FadeIn>

          <FadeIn delay={0.45} data-id="element-334">
            <div className="mt-5 flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-gray-400" data-id="element-335">
              <div className="flex items-center gap-2" data-id="element-336">
                <span className="text-gold" aria-hidden="true" data-id="element-337">
                  🛡️
                </span>
                <span data-id="element-338">Garantía 7 días</span>
              </div>
              <span className="text-white/20" aria-hidden="true" data-id="element-339">
                ·
              </span>
              <div className="flex items-center gap-2" data-id="element-340">
                <span className="text-gold" aria-hidden="true" data-id="element-341">
                  ⚡
                </span>
                <span data-id="element-342">Acceso inmediato</span>
              </div>
              <span className="text-white/20" aria-hidden="true" data-id="element-343">
                ·
              </span>
              <div className="flex items-center gap-2" data-id="element-344">
                <span className="text-gold" aria-hidden="true" data-id="element-345">
                  🔒
                </span>
                <span data-id="element-346">Pago 100% seguro</span>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Includes */}
        <FadeIn delay={0.3} data-id="element-347">
          <div className="max-w-5xl mx-auto mb-16" data-id="element-348">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-8 text-center" data-id="element-349">
              ✅ ¿QUÉ INCLUYE CADA UNO?
            </h3>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-350">
              {/* Base */}
              <div className="bg-surfaceLight/30 rounded-2xl p-6 md:p-8 border border-white/10" data-id="element-351">
                <div className="flex items-center gap-3 mb-6 pb-4 border-b border-white/10" data-id="element-352">
                  <span className="text-3xl" aria-hidden="true" data-id="element-353">
                    📘
                  </span>
                  <div data-id="element-354">
                    <h4 className="text-lg font-heading font-bold text-white" data-id="element-355">
                      SISTEMA MAESTRO PVC + DVH
                    </h4>
                    <p className="text-xs text-gray-400" data-id="element-356">
                      Incluido en ambos packs
                    </p>
                  </div>
                </div>
                <ul className="space-y-3" data-id="element-357">
                  {['6 Módulos completos (240+ páginas)', 'Bono 1 — Cierre Express PVC', 'Bono 2 — Mapa de Errores Fatales', 'Bono 3 — Guía de Entrega Premium'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-200" data-id="element-358">
                      <span className="text-gold mt-0.5 shrink-0" data-id="element-359">✓</span>
                      <span data-id="element-360">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* Pack Aceleración */}
              <div className="bg-surfaceLight/30 rounded-2xl p-6 md:p-8 border border-gold/30" data-id="element-361">
                <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gold/20" data-id="element-362">
                  <span className="text-3xl" aria-hidden="true" data-id="element-363">
                    🏆
                  </span>
                  <div data-id="element-364">
                    <h4 className="text-lg font-heading font-bold text-gold" data-id="element-365">
                      PACK DE ACELERACIÓN
                    </h4>
                    <p className="text-xs text-gray-400" data-id="element-366">
                      Incluido solo en el pack completo
                    </p>
                  </div>
                </div>
                <ul className="space-y-3" data-id="element-367">
                  {['📐 7 Tablas de Corte Ciego ya calculadas para pegar en el banco', '📋 4 Fichas de Relevamiento para llevar en la camioneta', '📄 3 Planillas de Pedido profesionales para vidriero y proveedor', '🚐 Checklist de Camioneta — nunca más volvés por lo que olvidaste', '📊 Catálogo Visual para mostrar al cliente en la visita', '🔍 Checklist de Auditoría para que el ayudante trabaje solo', '🤝 Guía de Proveedores — cómo comprar mejor y ganar más'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-200" data-id="element-368">
                      <span className="text-gold mt-0.5 shrink-0" data-id="element-369">✓</span>
                      <span data-id="element-370">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="mt-8 bg-gold/10 border border-gold/20 rounded-xl p-6 text-center max-w-3xl mx-auto" data-id="element-371">
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-372">
                <span className="text-gold font-bold" data-id="element-373">
                  💡 ¿Por qué el pack completo es la mejor opción?
                </span>{' '}
                Un solo cristal mal pedido cuesta entre $40.000 y $130.000 ARS.
                El Pack de Aceleración cuesta $10.000 más. Se paga solo en el
                primer trabajo donde no errás un cálculo.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <FadeIn delay={0.4} data-id="element-374">
          <div className="max-w-5xl mx-auto mb-16" data-id="element-375">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-10 text-center" data-id="element-376">
              ❤️ MÁS TALLERES QUE YA LO TIENEN
            </h3>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-377">
              {[{
              name: 'Diego V.',
              loc: '📍 Salta',
              plan: 'Pack completo',
              text: 'Pegué las tablas en el banco y mi ayudante cortó y pidió el cristal solo. No me llamó una vez.'
            }, {
              name: 'Esteban F.',
              loc: '📍 Tucumán',
              plan: 'Carpintero independiente',
              text: 'Con el Módulo 3 me di cuenta que llevaba meses calculando mal los descuentos. Me ahorré varias planchas de DVH en el primer mes.'
            }, {
              name: 'Pablo S.',
              loc: '📍 Mar del Plata',
              plan: 'Dueño de taller',
              text: 'Antes presupuestaba por lo que el cliente aceptaba. Ahora sé exactamente cuánto gano en cada obra antes de empezar.'
            }].map((t, i) => <div key={i} className="bg-surfaceLight p-6 rounded-2xl border border-white/5" data-id="element-378">
                  <div className="flex gap-1 mb-3" data-id="element-379">
                    {[...Array(5)].map((_, j) => <span key={j} className="text-gold text-sm" data-id="element-380">
                        ★
                      </span>)}
                  </div>
                  <p className="text-gray-300 mb-4 italic text-sm leading-relaxed" data-id="element-381">
                    "{t.text}"
                  </p>
                  <div className="text-xs" data-id="element-382">
                    <span className="font-bold text-white" data-id="element-383">{t.name}</span>
                    <span className="text-gray-500 mx-2" data-id="element-384">|</span>
                    <span className="text-gray-400" data-id="element-385">{t.loc}</span>
                    <span className="text-gray-500 mx-2" data-id="element-386">|</span>
                    <span className="text-gold" data-id="element-387">{t.plan}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Guarantee */}
        <FadeIn delay={0.5} data-id="element-388">
          <div className="max-w-3xl mx-auto bg-surfaceLight/50 rounded-3xl p-8 md:p-12 border border-white/10 text-center" data-id="element-389">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6 text-4xl border border-gold/20" data-id="element-390">
              🛡️
            </div>
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4" data-id="element-391">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h3>
            <p className="text-gray-300 text-lg mb-6" data-id="element-392">
              Abrís los módulos. Los usás en el taller y en la obra. Si en 7
              días no es lo que esperabas:
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-6 mb-8 text-white font-medium" data-id="element-393">
              <div className="flex items-center justify-center gap-2" data-id="element-394">
                <span className="text-gold" data-id="element-395">✅</span> Devolución del 100%
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-396">
                <span className="text-gold" data-id="element-397">✅</span> Sin formularios, sin drama
              </div>
            </div>
            <div className="inline-block bg-bg px-4 py-2 rounded-lg border border-white/5 text-sm text-gray-400" data-id="element-398">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </FadeIn>

        {/* FAQ */}
        <FadeIn delay={0.6} data-id="element-399">
          <div className="max-w-3xl mx-auto mt-16" data-id="element-400">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-8 text-center" data-id="element-401">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h3>
            <div className="space-y-4" role="list" data-id="element-402">
              {[{
              q: '¿Sirve si no uso Aluplast?',
              a: 'Sí. Cubre Aluplast, Kommerling, Rehau y sistemas nacionales.'
            }, {
              q: '¿Cómo recibo el material?',
              a: 'Inmediatamente después del pago. Menos de 5 minutos.'
            }, {
              q: '¿Puedo imprimirlo?',
              a: 'Sí. Todo está diseñado para imprimir y usar en el taller.'
            }, {
              q: '¿Sirve si empiezo de cero en PVC?',
              a: 'Sí. El Módulo 1 te lleva desde los fundamentos.'
            }, {
              q: '¿Necesito maquinaria especial?',
              a: 'No. Funciona con las herramientas que ya tenés.'
            }, {
              q: '¿Tiene garantía real?',
              a: 'Sí. 7 días, 100% de devolución, sin preguntas.'
            }].map((faq, i) => <div key={i} className="bg-surfaceLight border border-white/5 rounded-xl overflow-hidden" role="listitem" data-id="element-403">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-gold" aria-expanded={openFaq === i} aria-controls={`faq-answer-${i}`} data-id="element-404">
                    <span className="font-medium text-white pr-4" data-id="element-405">{faq.q}</span>
                    <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-406" />
                  </button>
                  {openFaq === i && <div id={`faq-answer-${i}`} className="px-6 pb-4 text-gray-400 text-sm" role="region" aria-label={faq.q} data-id="element-407">
                      {faq.a}
                    </div>}
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}